<template>
  <v-flex md12 xs12 class="mb-4">
    <v-card>
      <v-layout row wrap justify-start align-center>
        <v-flex md2 xs4>
          <v-layout row wrap justify-start align-center>
            <v-flex md12 py-0>
              <ProductImage :product="product"></ProductImage>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex md10 xs8>
          <v-card flat>
            <v-layout row wrap justify-center align-center>
              <v-flex fill-height md12 xs12>
                <v-layout row wrap justify-space-between align-center>
                  <v-flex fill-height md4 x12>
                    <v-card-title class="pt-0">{{product.prod_desc}}</v-card-title>
                    <v-card-subtitle v-if="product.variety != null || product.size != null">
                      <div>
                        <span v-if="product.variety != null">{{product.variety}}</span>
                        <span v-if="product.size != null">
                          <span v-if="product.variety != null">-</span>
                          {{product.size}}
                        </span>
                      </div>
                      <div>
                        <span v-if="product.country_of_origin != null">
                          Country:
                          <strong>{{product.country_of_origin}}</strong>
                        </span>
                      </div>
                    </v-card-subtitle>
                  </v-flex>

                  <v-flex fill-height md5 xs12>
                    <PriceDisplay v-bind:product="product"></PriceDisplay>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-card-actions class="hidden-sm-and-down">
              <v-btn
                outlined
                color="info"
                :to="{name: 'OrdersSearchProduct',  params: { id: product.prod_no ,product: product}}"
              >
                <v-icon>info</v-icon>
              </v-btn>
              <v-btn outlined dark color="favourites">
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn color="blue darken-2" dark>
                <v-icon>add</v-icon>Add
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-card-actions class="hidden-md-and-up">
        <v-btn
          outlined
          color="info"
          :to="{name: 'OrdersSearchProduct',  params: { id: product.prod_no , product: product}}"
        >
          <v-icon>info</v-icon>
        </v-btn>
        <v-btn outlined dark color="favourites">
          <v-icon>mdi-heart</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn color="blue darken-2" dark>
          <v-icon>add</v-icon>Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import ProductImage from "@/components/product/ProductImage.vue";
import PriceDisplay from "@/components/product/PriceDisplay.vue";

export default {
  components: {
    ProductImage,
    PriceDisplay
  },
  props: {
    product: {}
  }
};
</script>

<style lang="css" scoped>
* {
  word-break: break-word;
}

@media (min-width: 1264px) and (max-width: 1904px) {
  .flex.lg2 {
    flex-basis: 20%;
    flex-grow: 0;
    max-width: 20%;
  }
}

.v-card__title {
  font-size: 14px;
  font-weight: bold;
}

.v-card__subtitle {
  padding: 4px 1em;
}

@media (min-width: 1600px) {
  .col-md-3 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

@media (max-width: 600px) {
  .rowImage {
    margin: 0 auto;
  }
}

.v-card__actions {
  /* background-color: rgba(0, 0, 0, 0.04); */
}

.transparentBG {
  background-color: transparent;
}
</style>